import { Reveal, SectionHeading } from "./Reveal";
import { BENEFITS } from "@/data/site";

const WhyUs = () => (
  <section data-testid="why-us-section" className="bg-white py-24 md:py-32 lg:py-40">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid gap-14 lg:grid-cols-[0.85fr_1.15fr]">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <SectionHeading
            overline="Why Choose Prata Technologies"
            title="A Technology Partner, Not Just A Provider"
            text="We combine AI, automation and modern digital technology to solve practical business problems — with solutions designed for the long term."
          />
        </div>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {BENEFITS.map((benefit, i) => (
            <Reveal key={benefit.title} delay={i * 0.06}>
              <div
                data-testid={`benefit-card-${i}`}
                className="group h-full rounded-2xl border border-slate-200 bg-slate-50 p-7 transition-[background-color,border-color,box-shadow] duration-500 hover:border-electric/25 hover:bg-white hover:shadow-lg"
              >
                <benefit.icon
                  className="h-6 w-6 text-electric transition-transform duration-500 group-hover:scale-110"
                  strokeWidth={1.5}
                />
                <h3 className="mt-5 font-display text-lg font-medium text-slate-900">
                  {benefit.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{benefit.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyUs;
